// DM-2631: hides the checkbox pre-release since DM-2607's create-new-option UI/backend isn't shipping yet; flip to true in a DM-2607 PR.
export const SHOW_ALLOW_NEW_OPTIONS = false;
